import { WithTranslation } from 'react-i18next';
import { BrowserInterface } from '@api/store';
import { History } from '@dev/history';
import { RouteComponentProps } from 'react-router-dom';

import { StatisticsState } from '@api/store/statistics/types';
import { LogsState } from '@api/store/logs/types';
import { StatisticsChannelsState } from '@api/store/channels/types';
import { AccountState } from '@api/store/account/types';
import { CampaignsState } from '@api/store/campaigns/types';

type MatchParams = {
    search?: string;
};

export interface ChannelList {
    label: string;
    value: string;
    borderBottom?: boolean;
}

export interface ChartsData {
    Date?: string;
    Submitted?: string | number;
    Bounced?: string | number;
    Clicked?: string | number;
    Complaint?: string | number;
    Delivered?: string | number;
    Opened?: string | number;
    Unsubscribed?: string | number;
    Suppressed?: string | number;
}

export default interface StatisticsSummaryInterface extends WithTranslation, RouteComponentProps<MatchParams> {
    classes: any;
    history: History;
    browser: BrowserInterface;
    statistics?: StatisticsState;
    channels?: StatisticsChannelsState;
    logs?: LogsState;
}

export default interface StatisticsSummaryGraphInterface extends WithTranslation, RouteComponentProps<MatchParams> {
    classes: any;
    history: History;
    browser: BrowserInterface;
    statistics?: StatisticsState;
    channels?: StatisticsChannelsState;
    account?: AccountState;
    campaigns?: CampaignsState;
}

export enum DateDropdownOptions {
    Calendar = 'calendar',
    Last30days = '30',
}
